var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2416 2416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1208 604C522.257 604 100.665 1208 100.665 1208C100.665 1208 522.257 1812 1208 1812C1893.74 1812 2315.33 1208 2315.33 1208C2315.33 1208 1893.74 604 1208 604ZM1208 1610.67C811.07 1610.67 510.781 1360.61 364.512 1208C469.206 1098.78 652.62 940.529 893.415 858.787C836.709 929.245 805.648 1016.89 805.332 1107.33C805.332 1214.13 847.755 1316.55 923.27 1392.06C998.785 1467.58 1101.2 1510 1208 1510C1314.79 1510 1417.21 1467.58 1492.73 1392.06C1568.24 1316.55 1610.66 1214.13 1610.66 1107.33C1610.35 1016.89 1579.29 929.245 1522.58 858.787C1763.48 940.529 1946.99 1098.88 2051.48 1208C1905.01 1360.81 1604.83 1610.67 1208 1610.67V1610.67Z",
    className: "svgText"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.6fd1fb0b1bae734bc99c6e7fc5773836.svg";
export { ForwardRef as ReactComponent };